import * as React from 'react'
import {styled} from '@mui/material/styles'
import Chip from '@mui/material/Chip'
import Box from '@mui/material/Box'

const StyledListItem = styled('li')(({theme}) => ({
  margin: theme.spacing(0.5),
}))

export default function TagsDisplay({tags}: {tags: string[]}) {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'left',
        flexWrap: 'wrap',
        listStyle: 'none',
        p: 0,
        m: 0
      }}
      component="ul"
    >
      {tags.map((tag) => {
        return (
          <StyledListItem key={tag}>
            <Chip size='small' label={tag} />
          </StyledListItem>
        )
      })}
    </Box>
  )
}
